var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-6"},[_c('button',{staticClass:"settings__item",class:{'active': _vm.show},on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('img',{attrs:{"src":require("@/assets/icons/arrow.svg")}})]),(_vm.show)?_c('div',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }